import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MenuHomeEnum } from 'app/components/home';
import { MenuPermissionConfig, MenuPermissionActionEnum } from 'app/models';
import { AppComponent } from 'app/app.component';

export enum PartnerMartMarketingMenuEnum {
    AllPromotions = 1,
    Performance = 2,
    RecommendedPromo = 3
}

@Component({
    selector: 'partner-marketing-root',
    templateUrl: './partner-marketing-root.component.html',
    styleUrls: ['./partner-marketing-root.component.scss']
})
export class PartnerMarketingRootComponent implements OnInit {
    public menuEnum = MenuHomeEnum;
    public activeMenu: MenuHomeEnum = MenuHomeEnum.Marketing;

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public app: AppComponent) { }

    ngOnInit(): void { }

    public clickMenu(menuPermissionActive: string, menu: MenuHomeEnum) {
        this.menuPermissionActive = menuPermissionActive;
        this.activeMenu = menu;
    }
}
